import React from "react";
import PropTypes from "prop-types";
import Nav from "react-bootstrap/Nav";

function PillTabs({ items, current, setCurrentItem }) {
  const specialItems = items.filter(
    (item) => item.name === "InsightsSection" || item.name === "doctor_notes"
  );

  const hasOtherItems = items.some(
    (item) => item.name !== "InsightsSection" && item.name !== "doctor_notes"
  );

  // Sort and ensure the order: doctor_notes first, "YourResults" in the middle, InsightsSection last
  const displayItems = [
    specialItems.find((item) => item.name === "doctor_notes"),
    ...(hasOtherItems
      ? [{ name: "YourResults", label: "Your results", isCombined: true }]
      : []),
    specialItems.find((item) => item.name === "InsightsSection"),
  ].filter(Boolean); // Filter out undefined values if no special item exists

  return (
    <Nav className="gap-2 pb-2" variant="pills"  activeKey={current}>
      {displayItems.map((item) => (
        <Nav.Item key={item.name} className="">
          <button
            type="button"
            className={`pill-tab btn ${
              current === item.name ||
              (item.isCombined &&
                items.some(
                  (i) =>
                    i.name !== "InsightsSection" &&
                    i.name !== "doctor_notes" &&
                    i.name === current
                ))
                ? "active-tab text-white"
                : "text-teal"
            }`}
            onClick={() => {
              if (item.isCombined) {
                // Handle special combined behavior, pick the first non-special item
                const firstOther = items.find(
                  (i) => i.name !== "InsightsSection" && i.name !== "doctor_notes"
                );
              if(firstOther){ 
                setCurrentItem(firstOther.name);
              }
             } else {
                setCurrentItem(item.name);
              }
            }}
          >
            {item.label || item.name}
          </button>
        </Nav.Item>
      ))}
    </Nav>
  );
}

PillTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  current: PropTypes.string.isRequired,
  setCurrentItem: PropTypes.func.isRequired,
};

export default PillTabs;
